// import { useMemo } from 'react'
// import { Interface } from '@ethersproject/abi'
import BigNumber from 'bignumber.js'
import { useHostContract, useTokenContract, useRouterContract } from '../hooks/useContract'
import { useETHBalances } from '../state/wallet/hooks'

// import ERC20_ABI from '../constants/abis/erc20.json'
import { useSingleCallResult } from '../state/multicall/hooks'
import { USDT, MEME ,HOST_ADDRESS } from '../constants'

export function Host(owner?: string): any {
  const contract = useHostContract(false)
  const routerContract = useRouterContract(false)
  const tokenContract = useTokenContract(USDT.address, false)
  const userInfoRes = useSingleCallResult(contract, 'userInfo', [owner]).result
  const userInfo:any = userInfoRes ? {
    balance: Number(userInfoRes.balance.toString() / 10**18).toFixed(3),
    bnbFee: Number(userInfoRes.bnbFee.toString() / 10**18).toFixed(3),
    time: userInfoRes.time.toString()
  } : null

  const rewardInfoRes = useSingleCallResult(contract, 'getReward', [owner]).result
  const rewardInfo:any = rewardInfoRes ? {
    reward: Number(rewardInfoRes.reward.toString() / 10**18).toFixed(3),
    endTime: rewardInfoRes.endTime.toString(),
    canWithdraw: rewardInfoRes.canWithdraw
  } : null

  const tokenBalanceRes = useSingleCallResult(tokenContract, 'balanceOf', [owner]).result
  const tokenBalance = tokenBalanceRes ? Number(tokenBalanceRes.balance.toString()/10**18).toFixed(3) : '0.000'
  
  const tokenAllowanceRes = useSingleCallResult(tokenContract, 'allowance', [owner, HOST_ADDRESS]).result
  const tokenAllowance = tokenAllowanceRes ? Number(tokenAllowanceRes[0].toString()/10**18).toFixed(3) : '0.000'
  
  const bnbBalanceInfo:any = useETHBalances([owner])
  const bnbBalance = bnbBalanceInfo && owner && bnbBalanceInfo[owner] ? Number(bnbBalanceInfo[owner].raw.toString()/10**18).toFixed(3) : '0.000'
  const inputAmount = new BigNumber(100).multipliedBy(10 ** MEME.decimals).toFixed()
  const amountsRes = useSingleCallResult(routerContract, 'getAmountsOut', [inputAmount, [MEME.address, USDT.address]]).result
  // eslint-disable-next-line no-console
  console.log(amountsRes, 'amountsRes')
  const amounts = amountsRes ? amountsRes.amounts[1].toString() : 0
  const balanceMeme = userInfo ? userInfo.balance : 0
  const usdtAmount = balanceMeme === 0 || amounts === 0 ? '0.000' : new BigNumber(userInfo.balance).multipliedBy(new BigNumber(amounts).dividedBy(100).dividedBy(10 ** USDT.decimals)).toFixed(3)
  // eslint-disable-next-line no-console
  console.log(usdtAmount, 'usdtAmount')
  return {
    userInfo,
    rewardInfo,
    bnbBalance,
    tokenBalance,
    tokenAllowance,
    usdtAmount,
  };
}

export default Host
